export const alertText = "alert-text";
export const dangerText = "danger-text";
export const dangerBoldText = "danger-boldText";
